import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface, PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { AppComponent } from './app.component';
import { MainComponent } from './layout/main/main.component';
import { TranslateLoader, TranslateModule, TranslateStore } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { PopupModule } from '@progress/kendo-angular-popup';
import { LibAuthInterceptor, LibBusService, LibDialogEntityDetailService, LibDialogEntityFormService, LibDialogEntityManagerService, LibDialogService, LibDocumentService, LibHttpErrorHandler, LibMessageService, LibNoteService, LibSearchService, LibSpinnerInterceptor } from 'ngx-mat-base-comp';
import { NgxPermissionsModule } from 'ngx-permissions';
import { environment } from 'src/environments/environment';
import { LoginComponent } from './auth/login/login.component';
import { LogService } from './shared/log/log.service';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 2,
  wheelPropagation: true
};


@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    LoginComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    HttpClientModule,
    FlexLayoutModule,
    PerfectScrollbarModule,
    NgxPermissionsModule.forRoot(),
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
    },
      defaultLanguage: 'en',
      extend: true
    }),
    DropDownsModule,
    DateInputsModule,
    PopupModule
  ],
  providers: [
    LibHttpErrorHandler,
    LibMessageService,
    LibDialogService,
    LibDocumentService,
    LibNoteService,
    LibDialogEntityDetailService,
    LibDialogEntityFormService,
    LibDialogEntityManagerService,
    LibBusService,
    LibSearchService,
    TranslateStore,
    { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG },
    { provide: HTTP_INTERCEPTORS, useClass: LibAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LibSpinnerInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { 
  constructor(logService: LogService,
  private libBusService: LibBusService
  ){
    libBusService.module = '';
    
    if (environment.production || environment.name !== 'local') {
      if(window){ //intercept console errors and send to backend
      //  window.console.error = logService.sendConsoleError.bind(logService); 
      }
    }
  }
}

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}
